module.exports = __webpack_public_path__ + "img/palace.f7dde82c.png";